import { getNoAdminTeacher } from 'helpers/methods';
import React, { useState, useEffect } from 'react';
import { AsyncPaginate } from 'react-select-async-paginate';
import theme from '../../theme';
import { api_get, api_post } from 'utils/Api';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import {
    Button,
    Card,
    CardContent,
    CardActions,
    Avatar,
    Typography,
    Chip,
    Grid,
    Box,
} from '@material-ui/core';

const AssignSwitchTeacher = ({ isAdmin }) => {
    const { id } = useParams();
    const [assignedTeachers, setAssignedTeachers] = useState([]);
    const [values, setValues] = useState({ instructor: '' });


    const isAdminUser = isAdmin === "1";

    const fetchAssigned = async () => {
        if (!id) return;

        // Use different endpoint based on isAdmin value
        const endpoint = isAdminUser
            ? `teachers/${id}/assigned-teachers`
            : `teachers/${id}/admin-teachers`;

        const data = await api_get(endpoint);

        // Handle empty state - ensure we always have an array
        if (!data || !data.payload) {
            setAssignedTeachers([]);
            return;
        }

        setAssignedTeachers(Array.isArray(data.payload) ? data.payload : []);
    };

    useEffect(() => {
        fetchAssigned();
    }, [id]);

    const handleAssignTeacher = async () => {
        if (!values?.instructor?.id || !id) return;
        const res = await api_post(`teachers/assign-to-admin-teacher`, {
            teacherId: values.instructor.id,
            adminTeacherId: id,
        });

        await fetchAssigned();

        setValues((v) => ({ ...v, instructor: '' }));
        console.log(res);
    };

    const handleDeleteAssign = async (teacherId) => {
        if (!teacherId || !id) return;

        const payload = isAdminUser
            ? { teacherId, adminTeacherId: id }
            : { teacherId: id, adminTeacherId: teacherId };

        const res = await api_post(`teachers/remove-from-admin-teacher`, payload);

        setAssignedTeachers((prev) => prev.filter((t) => t.id !== teacherId));
        console.log(res);
    };

    const instructorChange = (value) => {
        if (value) setValues({ ...values, instructor: value });
        else setValues({ ...values, instructor: '' });
    };

    const subjectChips = (instructor_subjects = []) =>
        (instructor_subjects || []).slice(0, 4).map((s) => {
            const subj = s?.subject?.name;
            const div = s?.subject?.division?.name;
            const label = [subj, div].filter(Boolean).join(' — ');
            return <Chip key={s.id} label={label} size="small" style={{ marginRight: 6, marginBottom: 6 }} />;
        });

    const hasAssigned = assignedTeachers?.length > 0;

    return (
        <div>
            {/* Only show select input and Save button if isAdmin === "1" */}
            {isAdminUser && (
                <Box display="flex" alignItems="center" gridGap={12} mb={2}>
                    <Box flex={1}>
                        <AsyncPaginate
                            loadOptions={getNoAdminTeacher}
                            value={values.instructor}
                            onChange={instructorChange}
                            getOptionLabel={(option) => `${option?.name || ''} ${option?.last_name || ''}`.trim()}
                            getOptionValue={(option) => option?.id}
                            placeholder="Teachers"
                            additional={{ page: 1 }}
                            styles={{
                                control: (base) => ({ ...base, height: '53px' }),
                                placeholder: (base) => ({
                                    ...base,
                                    color: '#000',
                                    fontSize: theme.typography.fontSize,
                                    fontFamily: theme.typography.fontFamily,
                                }),
                            }}
                            menuPortalTarget={typeof document !== 'undefined' ? document.querySelector('body') : null}
                        />
                    </Box>

                    <Button color="primary" variant="contained" onClick={handleAssignTeacher} disabled={!values?.instructor?.id}>
                        Save details
                    </Button>
                </Box>
            )}

            <Box mt={3}>
                <Typography variant="h6" style={{ marginBottom: 12 }}>
                    {isAdminUser ? 'Assigned teachers' : 'Admin teachers'}
                </Typography>

                {!hasAssigned && (
                    <Typography variant="body2" color="textSecondary">
                        {isAdminUser ? 'No teachers assigned yet.' : 'No admin teachers assigned yet.'}
                    </Typography>
                )}

                {hasAssigned && (
                    <Grid container spacing={2}>
                        {assignedTeachers.map((t) => (
                            <Grid item xs={12} sm={6} md={4} lg={3} key={t.id}>
                                <Card variant="outlined">
                                    <CardContent>
                                        <Box display="flex" alignItems="center" mb={1}>
                                            <Avatar
                                                alt={`${t.name || ''} ${t.last_name || ''}`}
                                                src={t.avatar || undefined}
                                                style={{ marginRight: 12 }}
                                            >
                                                {(t.name?.[0] || '').toUpperCase()}
                                            </Avatar>
                                            <Box>
                                                <Typography variant="subtitle1">
                                                    {[t.name, t.last_name].filter(Boolean).join(' ')}
                                                </Typography>
                                                {t.email && (
                                                    <Typography variant="body2" color="textSecondary">
                                                        {t.email}
                                                    </Typography>
                                                )}
                                                {t.phone && (
                                                    <Typography variant="body2" color="textSecondary">
                                                        {t.phone}
                                                    </Typography>
                                                )}
                                            </Box>
                                        </Box>

                                        {/* Subjects / Divisions (first few) */}
                                        <Box mt={1} style={{ display: 'flex', flexWrap: 'wrap' }}>
                                            {subjectChips(t.instructor_subjects)}
                                            {t.instructor_subjects?.length > 4 && (
                                                <Chip
                                                    size="small"
                                                    label={`+${t.instructor_subjects.length - 4} more`}
                                                    style={{ marginBottom: 6 }}
                                                />
                                            )}
                                        </Box>
                                    </CardContent>

                                    <CardActions>
                                        <Button
                                            size="small"
                                            color="secondary"
                                            onClick={() => handleDeleteAssign(t.id)}
                                        >
                                            Delete
                                        </Button>
                                    </CardActions>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                )}
            </Box>
        </div>
    );
};

export default AssignSwitchTeacher;